"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = Spinner;

var _web = require("react-spring/web.cjs");

var _theme = require("@tablekit/theme");

var _styledContainer = require("./components/styledContainer");

var _styledSvg = _interopRequireDefault(require("./components/styledSvg"));

var _core = require("@emotion/core");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};

  var target = _objectWithoutPropertiesLoose(source, excluded);

  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

function Spinner(_ref) {
  var _ref$delay = _ref.delay,
      delay = _ref$delay === void 0 ? 100 : _ref$delay,
      _ref$isCompleting = _ref.isCompleting,
      isCompleting = _ref$isCompleting === void 0 ? false : _ref$isCompleting,
      _ref$onComplete = _ref.onComplete,
      onComplete = _ref$onComplete === void 0 ? function () {} : _ref$onComplete,
      className = _ref.className,
      _ref$size = _ref.size,
      size = _ref$size === void 0 ? _theme.SIZES.REGULAR : _ref$size,
      restProps = _objectWithoutProperties(_ref, ["delay", "isCompleting", "onComplete", "className", "size"]);

  var transitions = (0, _web.useTransition)(!isCompleting, null, {
    from: {
      opacity: 0,
      transform: 'rotate(50deg)'
    },
    enter: {
      opacity: 1,
      transform: 'rotate(230deg)',
      delay: delay
    },
    leave: {
      opacity: 0,
      transform: 'rotate(510deg)'
    },
    onDestroyed: function onDestroyed(isRemoved) {
      if (isRemoved) onComplete();
    }
  });
  return (0, _core.jsx)(_styledContainer.Outer, _extends({}, restProps, {
    className: className,
    size: size
  }), transitions.map(function (_ref2) {
    var item = _ref2.item,
        key = _ref2.key,
        styles = _ref2.props;
    return item && (0, _core.jsx)(_styledContainer.Container, {
      key: key,
      size: size,
      style: {
        opacity: styles.opacity.interpolate({
          range: !item ? [0, 0.45, 1] : [0, 1],
          output: !item ? [0, 0, 1] : [0, 1]
        }),
        transform: styles.transform
      }
    }, (0, _core.jsx)(_styledSvg["default"], {
      focusable: "false",
      viewBox: "0 0 100 100",
      xmlns: "http://www.w3.org/2000/svg"
    }, (0, _core.jsx)("circle", {
      cx: "50",
      cy: "50",
      r: "45"
    })));
  }));
}